import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type CreateAxnCompanyRequestResponse = {
    response: AxnCompany;
};

export const createAxnCompanyRequest = async (
    name: string,
    companyCode: string, customerSupportTierUID: string
): Promise<GenericNetworkResponse<CreateAxnCompanyRequestResponse>> => {
    const route = apiRoutes.axnadminCore.data.axncompany;
    const body = {
        name,
        companyCode,
        type: "RP",
        customerSupportTierUID
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};